import Vue from "vue";
import BootstrapVue from "bootstrap-vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import MoonLoader from "./components/MoonLoader.vue";
import "./assets/css/style.css";
import VueCtkDateTimePicker from "vue-ctk-date-time-picker";
import "vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css";
import VueClipboard from "vue-clipboard2";
import { BAlert } from "bootstrap-vue";
import VeeValidate from "vee-validate";

import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";

Vue.use(BootstrapVue);
Vue.component("b-alert", BAlert);
Vue.use(VueClipboard);

Vue.prototype.$handleError = async (error: any, callback: any) => {
  if (!callback) {
    console.error(error);
    if (error.name === "Network Error")
      alert(
        "Something went wrong with the network connection to the server. Are you connected?"
      );
    else {
      let message =
        error?.response?.data ??
        error?.response ??
        JSON.stringify(error?.message ?? error);
      alert(`An error has ocurred: ${JSON.stringify(message)}`);
    }
  } else {
    callback(error);
  }
};

Vue.component("moon-loader", MoonLoader);
Vue.component("VueCtkDateTimePicker", VueCtkDateTimePicker);
Vue.use(VeeValidate, {
  classes: true,
  events: "input|blur",
  fieldsBagName: "veevalidateFields",
});

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
